import FileInput from '@amzn/meridian/file-input';
import { localizeWithRef } from './localize';

export default localizeWithRef(FileInput, ['children', 'uploadButtonLabel']);
